export default {
  DOWNLOAD_START: 'Téléchargement… Veuillez patienter…',
  DOWNLOAD_SUCCESS: 'Merci beaucoup! Vous pouvez maintenant fermer cette fenêtre.'
}
